import shadows from './shadows'
import transitions from './transitions'
import spacing from './spacing'
import color from './color'
import type from './type'
import elevation from './elevation'

import styles from './styles'

export const THEME = {
    shadows,
    transitions,
    spacing,
    color,
    type,
    styles,
    elevation
}


// WEBPACK FOOTER //
// ./src/theme/index.js